import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { ResidentialComponent } from './components/residential/residential.component';
import { CommercialComponent } from './components/commercial/commercial.component';
import { CampusComponent } from './components/campus/campus.component';
import { EHouseComponent } from './components/e-house/e-house.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ResidentialComponent,
    CommercialComponent,
    CampusComponent,
    EHouseComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
